
export default {
  getName: (state) => state.name,
  getNextSeqCode: (state) => state.nextSeqCode,

  getMacroActivities: (state) => state.macroActivities,
}